import React from 'react';

const KeyTermsUsed = () => (
  <div>
    <h3>
      KEY TERMS USED IN THE GUIDE
    </h3>
    <div>
      <h4>
        API
      </h4>
      Application Porgramming Interface (API) is a technology that enables two applications to communicate with one
      another, allowing seamless movement of data from one application to another through a secure interface. The API
      will enable jurisdictions to push the recall data on their local portal to the OECD portal.
    </div>
    <br/>
    <div>
      <h4>API key</h4>
      An API key is a unique identifier aimed to ensure that the recalls are being uploaded/modified/deleted by the
      right person/server within an organisation.
    </div>
    <br/>
    <div>
      <h4>Integration report</h4>
      Each time a submission is made to the portal (i.e. request to add new recalls, and update or delete existing
      recalls), the user/server receives an integration report which either confirms that the request has been
      successfully integrated into the portal or provides information on any errors. This report is provided to the
      user/server <i>via</i> email.
    </div>
    <br/>
    <div>
      <h4>User/server</h4>
      In the guide, the term “user” refers to an actual person preparing and sending the recalls for uploads through the
      manual uploading process while the term “server” refers to the same work being carried out by a machine
      (i.e. <i>via</i> the automated upload process).
    </div>
    <br/>
    <div>
      <h4>XML</h4>
      This is the format used to prepare submissions for inserting, updating or deleting recalls in the portal.
    </div>
  </div>
);

export default KeyTermsUsed;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/key-terms-used.js